<template>
  <v-container fluid class="pa-0">
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="8" class="pa-2 pt-0">
        <LastMatchdayGamesWidget
          :seasonId="currentUser.league.seasonId"
          @heightChange="lastMatchdayGameHeight=$event"
        ></LastMatchdayGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <LastPlayersSearch v-bind:style="{'height':lastMatchdayGameHeight+'px'}"></LastPlayersSearch>
      </v-col>
      <v-col cols="12" md="8" class="pa-2">
        <ClientsLastLogin
          class="elevation-2"
          @heightChange="chartsHeight=$event"
        ></ClientsLastLogin>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <FavoritesWidget
          :userId="currentUser.id"
          v-bind:style="{'height':chartsHeight+'px'}"
        ></FavoritesWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="currentUser.league && currentUser.league.seasonId">
        <NextMatchdayGamesWidget
          :seasonId="currentUser.league.seasonId"
          @heightChange="nextMatchdayGameHeight=$event"
        ></NextMatchdayGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <CollectionsWidget v-bind:style="{'height':nextMatchdayGameHeight+'px'}"></CollectionsWidget>
      </v-col>
      <v-col cols="12" class="pa-2">
        <ReportsWidget @heightChange="reportsHeight=$event" style="min-height:260px"></ReportsWidget>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LastMatchdayGamesWidget from "./widgets/LastMatchdayGamesWidget";
import NextMatchdayGamesWidget from "./widgets/NextMatchdayGamesWidget";
import FavoritesWidget from "./widgets/FavoritesWidget";
import CollectionsWidget from "./widgets/CollectionsWidget";
import LastPlayersSearch from "./widgets/LastPlayersSearch";
import ReportsWidget from './widgets/ReportsWidget';
import ChartsWidget from './widgets/ChartsWidget';
import HotPlayersWidget from './widgets/HotPlayersWidget';
import ClientsLastLogin from "./widgets/ClientsLastLogin.vue";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "DriblabDashboard",
  props: {},
  components: {
    LastMatchdayGamesWidget,
    NextMatchdayGamesWidget,
    LastPlayersSearch,
    FavoritesWidget,
    CollectionsWidget,
    ChartsWidget,
    ReportsWidget,
    HotPlayersWidget,
    ClientsLastLogin,
    ScoutingTasksWidget,
    LastScoutingAnalysesWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  data() {
    return {
      loading: false,
      lastMatchdayGameHeight: null,
      nextMatchdayGameHeight: null,
      reportsHeight: null,
      chartsHeight: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {}
  }
};
</script>
